<template>
  <div class="content-wrapper">
    <div class="container-lg">
      <div class="row mb-12">
        <div class="col">
          <div class="page-title-nav row">
            <div class="col-2 col-lg-3">
              <router-link
                                :to="`/member/home`"
                                class="btn btn-outline-secondary btn-custom btn-back">
                                <i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                            </router-link>

            </div>
            <div class="col-8 col-lg-6">
              <h1 class="page-title">แทงหวย</h1>
            </div>
            <div class="col-12 col-lg-3">
              <a href="" class="btn btn-primary btn-custom d-none"><i
                  class="fa-icon fa-regular fa-home"></i><span>button</span></a>
            </div>
          </div>
          <!-- /ยี่กี/ -->
          <div class="section-title collapsible">
            <h4>หวยยี่กี</h4>
            <hr class="flex-grow-1">
            <a class="btn btn-outline-secondary btn-custom btn-sm d-none" data-bs-toggle="collapse"
              href="#collapseExample" role="button"><i class="fa-icon fa-regular fa-minus"></i><span
                class="btn-label"></span></a>
          </div>
          <div class="section-grid section-lotto mb-8" id="collapseExample">
            <template>
              <div v-for="(itemX, indexX) in dummyList.getYeekiCatalogList" :key="'bb'+indexX">
                <router-link :to="`lottoYeekeelist/${itemX.subCatID}`">
                  <a class="lotto-card">
                    <div class="lotto-card-header">
                      <i class="flag-icon flag-numbers"></i>
                      <h5>{{ itemX.subCatName }}</h5>
                    </div>
                    <div class="lotto-card-body">
                      <div class="d-grid">
                        <span class="countdown">{{ itemX.subCatDetail }} รอบ 24 ชม.</span>
                      </div>
                    </div>
                  </a>

                </router-link>
              </div>
            </template>
          </div>
          <!-- /หวยไทย/ -->

          <div class="section-title collapsible">
            <h4>หวยไทย</h4>
            <hr class="flex-grow-1">
            <a class="btn btn-outline-secondary btn-custom btn-sm d-none" data-bs-toggle="collapse"
              href="#collapseExample" role="button"><i class="fa-icon fa-regular fa-minus"></i><span
                class="btn-label"></span></a>
          </div>

          <div class="section-grid section-lotto mb-8" id="collapseExample">
            <template
              v-for="(lotto, index) in ((getLotteryList.length == 0) ? dummyList.getLotteryList : getLotteryList)">
              <template v-if="index === 0">
                <!-- <pre :key="index">{{ lotto.list  }}</pre> -->
                <template
                  v-for="(item, indexSub) in (lotto.list.filter(v => v.isOpen === '1').sort(function (a, b) { return isATimeOver(a.lottoCloseTime, b.lottoCloseTime) ? -1 : 1 }))">
                  <router-link :key="'cc'+indexSub"
                    v-bind:to="item.isOpen !== '1' ? `/member/lotto/${item.lottoId}` : `/member/lotto/${item.lottoId}`">
                    <a class="lotto-card">
                      <div class="lotto-card-header">
                        <img :src="require('@/assets/flags/'+item.lottoImage)" class="jss86 -img img_left pt-2" alt="Lotmatic แทงหวยออนไลน์" width="40" >
                        <!-- <i class="flag-icon flag-th"></i> -->
                        <h5>{{ item.titleLottoCatagory }}</h5>
                        <!-- <span v-bind:class="getIconClass(lotto.titleLottoCatagory)"></span>
                        <h5>{{ lotto.titleLottoCatagory }}</h5> -->
                      </div>
                      <div class="lotto-card-body">
                        <p>งวดวันที่ {{ item.lottoName }}</p>
                        <div class="d-grid">
                          <span class="expire-on">ปิดรับ {{ getTime(item.lottoCloseTime) }}</span>
                          <span class="countdown" v-if="item.isOpen === '1'" id="offset" data-finaldate="1610871600000"
                            v-html="calTime(item.lottoCloseTime)">
                            <i class="fa-icon fa-regular fa-timer"></i>
                          </span>
                          <span class="countdown" v-else><i class="fas fa-ban"></i><span>ยังไม่รับแทง</span></span>
                        </div>
                      </div>
                    </a>
                  </router-link>
                </template>
                <template v-for="(item, indexSub) in lotto.list.filter(v => v.isOpen !== '1')">
                  <router-link :key="'dd'+indexSub"
                    v-bind:to="item.isOpen !== '1' ? `/member/lotto/${item.lottoId}` : `/member/lotto/${item.lottoId}`">
                    <a class="lotto-card">
                      <div class="lotto-card-header">
                        <i class="flag-icon flag-th"></i>
                        <h5>{{ item.titleLottoCatagory }}</h5>
                      </div>
                      <div class="lotto-card-body">
                        <p>งวดวันที่ {{ item.lottoName }}</p>
                        <div class="d-grid">
                          <span class="expire-on">ปิดรับ {{ getTime(item.lottoCloseTime) }}</span>
                          <span class="countdown" v-if="item.isOpen === '1'" id="offset" data-finaldate="1610871600000"
                            v-html="calTime(item.lottoCloseTime)">
                            <i class="fa-icon fa-regular fa-timer"></i>
                          </span>
                          <span class="countdown" v-else><i class="fas fa-ban"></i><span>ยังไม่รับแทง</span></span>
                        </div>
                      </div>
                    </a>
                  </router-link>
                </template>
              </template>
            </template>

          </div>
          <!-- /หวยชุด/ -->
          <div class="section-title collapsible">
            <h4>หวยชุด</h4>
            <hr class="flex-grow-1">
            <a class="btn btn-outline-secondary btn-custom btn-sm d-none" data-bs-toggle="collapse"
              href="#collapseExample" role="button"><i class="fa-icon fa-regular fa-minus"></i><span
                class="btn-label"></span></a>
          </div>
          <div   class="section-grid section-lotto" id="collapseExample">
              <template v-for="(lotto, index) in list">
            <router-link :key="'ee'+index"
                :to="`/member/lottery/lottoset/${lotto.LottoCatagory.lottoId}`"
              >
            <a class="lotto-card">
              <div class="lotto-card-header">
                <span v-bind:class="getIconClass(lotto.titleLottoCatagory)"></span>
                <h5>{{ lotto.titleLottoCatagory }}</h5>
              </div>
              <div class="lotto-card-body">
                <p>{{ lotto.titleLottoCatagory }}</p>
                <div class="d-grid">
                  <span class="expire-on bg-dark text-white">เปิดแทง</span>
                </div>
              </div>
            </a>
            </router-link>
          </template>
          </div>

          <!-- /หวยหุ้น/ -->
          <div class="section-title collapsible">
            <h4>หวยหุ้น</h4>
            <hr class="flex-grow-1">
            <a class="btn btn-outline-secondary btn-custom btn-sm d-none" data-bs-toggle="collapse"
              href="#collapseExample" role="button"><i class="fa-icon fa-regular fa-minus"></i><span
                class="btn-label"></span></a>
          </div>
          <div class="section-grid section-lotto" id="collapseExample">
            <template
              v-for="(lotto, index) in ((getLotteryList.length == 1) ? dummyList.getLotteryList : getLotteryList)">
              <template v-if="index === 1">
                <!-- <pre :key="index">{{ lotto.list  }}</pre> -->
                <template
                  v-for="(item, indexSub) in (lotto.list.filter(v => v.isOpen === '1').sort(function (a, b) { return isATimeOver(a.lottoCloseTime, b.lottoCloseTime) ? -1 : 1 }))">
                  <router-link :key="'ff'+indexSub"
                    v-bind:to="item.isOpen !== '1' ? `/member/lotto/${item.lottoId}` : `/member/lotto/${item.lottoId}`">
                    <a class="lotto-card">
                      <div class="lotto-card-header">
                        <span v-bind:class="getIconClass(item.titleLottoCatagory)"></span>
                        <h5>{{ item.titleLottoCatagory }}</h5>
                      </div>
                      <div class="lotto-card-body">
                        <p>งวดวันที่ {{ item.lottoName }}</p>
                        <div class="d-grid">
                          <span class="expire-on">ปิดรับ {{ getTime(item.lottoCloseTime) }}</span>
                          <span class="countdown" v-if="item.isOpen === '1'" id="offset" data-finaldate="1610871600000"
                            v-html="calTime(item.lottoCloseTime)">
                            <i class="fa-icon fa-regular fa-timer"></i>
                          </span>
                          <span class="countdown" v-else><i class="fas fa-ban"></i><span>ยังไม่รับแทง</span></span>
                        </div>
                      </div>
                    </a>
                  </router-link>
                </template>
                <template v-for="(item, indexSub) in lotto.list.filter(v => v.isOpen !== '1')">
                  <!-- {{ item }} -->
                  <router-link :key="'gg'+indexSub"
                    v-bind:to="item.isOpen !== '1' ? `/member/lotto/${item.lottoId}` : `/member/lotto/${item.lottoId}`">
                    <a class="lotto-card">
                      <div class="lotto-card-header">
                        <span v-bind:class="getIconClass(item.titleLottoCatagory)"></span>
                        <h5>{{ item.titleLottoCatagory }}</h5>
                      </div>
                      <div class="lotto-card-body">
                        <p>งวดวันที่ {{ item.lottoName }}</p>
                        <div class="d-grid">
                          <span class="expire-on">ปิดรับ {{ getTime(item.lottoCloseTime) }}</span>
                          <span class="countdown" v-if="item.isOpen === '1'" id="offset" data-finaldate="1610871600000"
                            v-html="calTime(item.lottoCloseTime)">
                            <i class="fa-icon fa-regular fa-timer"></i>
                          </span>
                          <span class="countdown" v-else><i class="fas fa-ban"></i><span>ยังไม่รับแทง</span></span>
                        </div>
                      </div>
                    </a>
                  </router-link>
                </template>
              </template>
            </template>
          </div>

        </div>
      </div>
      <div class="push">
        <!-- <template>
            <div class="col-6 col-sm-6 col-md-6 col-lg-3 order-2"  v-for="(itemX, indexX) in dummyList.getYeekiCatalogList" :key="indexX">
              <router-link :to="`/member/lottery/yeeki/${itemX.subCatID}`">
                <div class="lotto-card">
                  <div class="ribbon-lotto"><i class="fas fa-trophy"></i></div>
                  <div class="lotto-head" v-bind:class="itemX.styleName" >
                    <h5>{{itemX.subCatName}}</h5>
                    <span class="badge" v-bind:class="itemX.styleBadgeName">{{itemX.subCatDetail}}</span>
                  </div>
                  <div class="lotto-time">
                    <div class="txt-24">
                      <i class="far fa-check-circle"></i>
                      <span id="offset">24 ชม.</span>
                    </div>
                  </div>
                </div>

              </router-link>
            </div>
          </template> -->
        <!-- <pre class="text-white">{{ getLotteryList  }}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getAvailableLottoSet } from '@/services'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { dummyList } from '@/constants'
import {
  getClassIcons,
  getClassBackgroundIcons
} from '@/utils'
export default {
  data () {
    return {
      dummyList: dummyList,
      currentDate: '',
      show: true,
      list: []
    }
  },
  async created () {
    if (this.isGamePermission === 2) {

    }
    const resp = await getAvailableLottoSet()
    if (resp.status_code === 'SUCCESS') {
      this.list = resp.data.listAvaliableLotto[0].list
    }
    this.setLoading(true)
    setInterval(() => {
      this.getNow()
    }, 1000)
    await this.getYeekiCatalog()
    await this.getLottoInter()
    this.setLoading(false)
  },
  methods: {
    ...mapActions(['getLottery', 'setLoading', 'getLottoInter', 'getYeekiCatalog']),
    getIconClass (title) {
      if (title) {
        return getClassIcons(title)
      } else {
        return ''
      }
    },
    getBackgroundColor (title) {
      if (title) {
        const classes = getClassBackgroundIcons(title)
        return classes
      } else {
        return ''
      }
    },
    calTime (value) {
      const final = moment(value)
      const now = this.currentDate ? this.currentDate : ''
      const timeleft = final - now
      if (timeleft > 0) {
        const days = Math.floor(timeleft / (1000 * 60 * 60 * 24))
        let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60))
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        let seconds = Math.floor((timeleft % (1000 * 60)) / 1000)
        if (seconds < 10) {
          seconds = '0' + seconds
        }
        if (hours < 10) {
          hours = '0' + hours
        }
        if (days > 1000) {
          return ''
        } else if (days > 0) {
          return `${days}<small>วัน</small> ${hours}<small>:</small>${minutes}<small>:</small>${seconds}`
        } else {
          return `${hours}<small>:</small>${minutes}<small>:</small>${seconds}`
        }
      } else {
        return '00<small>:</small>00<small>:</small>00'
      }
    },
    getIsClose (value) {
      const final = moment(value)
      const now = this.currentDate ? this.currentDate : ''
      const timeleft = final - now
      if (timeleft > 0) {
        return false
      } else {
        return true
      }
    },
    getTime (time) {
      const timer = moment(time)
      const min = timer.minutes().toString()
      const hour = timer.hours().toString()
      const pad = '00'
      const minCal = pad.substring(0, pad.length - min.length) + min
      const hourCal = pad.substring(0, pad.length - hour.length) + hour

      return `${hourCal}: ${minCal}`
    },
    getNow () {
      this.currentDate = moment()
    },
    getTimeStamp (time) {
      return moment(time)
    },
    isATimeOver (a, b) {
      return moment(a) < moment(b)
    }
  },
  computed: {
    ...mapGetters(['getLotteryList', 'getYeekiCatalogList']),
    ...mapState({
      isGamePermission: (state) => state.authModule.isGamePermission
    })
  }
}
</script>
